export default __webpack_public_path__ + "static/media/Corpaybanner.a6bd1de6.png";